module.exports = __webpack_public_path__ + "img/mercedes-eqc-page-gal-1.d0af97f5.jpg";